import { RoutineApi } from '~/common/api/zeiterfassungServerApi/RoutineApi';
import { DefaultSpinner } from '~/common/components/defaultUIComponents';
import { RoutineHeaderStack } from './RoutineHeaderStack';
import { RoutineContextProvider } from './RoutineContext';
import { ListView } from '~/common/components/ListView';
import { format, subDays, addDays } from 'date-fns';
import { Paper } from '~/common/components/Paper';
import RoutineTile from './RoutineTile';
import React, { useState } from 'react';
import _ from 'lodash';

const Routines: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const today = new Date();
  const initialStartDate = format(subDays(today, 5), 'yyyy-MM-dd');
  const initialEndDate = format(addDays(today, 1), 'yyyy-MM-dd');
  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const [{ data: routines, isLoading }] = RoutineApi.hooks.useRoutinesQuery();

  return (
    <RoutineContextProvider
      value={{
        searchTerm,
        setSearchTerm,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
      }}
    >
      <RoutineHeaderStack />
      {!routines && isLoading && <DefaultSpinner height="unset" mt={5} />}
      <ListView
        data={_.orderBy(routines, 'name')}
        searchFields={(r) => [r.name]}
        search={searchTerm}
        mt={5}
        render={({ data }) => {
          return (
            <>
              {data?.map((routine) => (
                <React.Fragment key={routine.id}>
                  <Paper>
                    <RoutineTile key={routine.id} routine={routine} />
                  </Paper>
                </React.Fragment>
              ))}
            </>
          );
        }}
      />
    </RoutineContextProvider>
  );
};

export default Routines;
